//配送单API
import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findDistributionSheetList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/distributionSheet?` + params,
        method: 'GET'
    })
}
export const viDistributionSheetList = (params) => { //配送单列表
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/distributionSheet/list?` + params,
        method: 'GET'
    })
}
export const viDistributionSheetListDownloadExcel = (params) => { //配送单列表
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/distributionSheet/excel?` + params,
        method: 'GET'
    })
}
export const viDistributionSheetFindDetail = (id) => { //配送单详情
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/distributionSheet/findDetail/${id}`,
        method: 'GET'
    })
}
export const payDistributionFee = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/distributionSheet/payDistributionFee/${id}`,
        method: 'GET'
    })
}
export const payWXDistributionFee = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/distributionSheet/balancePay/${id}`,
        method: 'GET'
    })
}